import { render, staticRenderFns } from "./getCoupons.vue?vue&type=template&id=1c9eb92a&scoped=true"
import script from "./getCoupons.vue?vue&type=script&lang=js"
export * from "./getCoupons.vue?vue&type=script&lang=js"
import style0 from "./getCoupons.vue?vue&type=style&index=0&id=1c9eb92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9eb92a",
  null
  
)

export default component.exports